import { Component } from '@angular/core';

@Component({
  selector: 'app-subscription-banner-trial-property',
  templateUrl: './subscription-banner-trial-property.component.html',
  styleUrls: ['./subscription-banner-trial-property.component.scss'],
  standalone: false
})
export class SubscriptionBannerTrialPropertyComponent {
}
